import { Mail } from 'lucide-react'
import { CONTACT, ContactChannel } from '@/content/contact'
import { trackUsage, UsageEvent } from '@/core/reporting'
import { TEST_IDS } from '@/lib/testIds'
import { cn } from '@/lib/utils'
import { AppVersion } from '@/ui/AppVersion'
import { InstagramGlyph } from '@/ui/icons/InstagramGlyph'

interface ContactLinksProps {
  className?: string
  prompt?: string
  showFooter?: boolean
}

function contactClicked(channel: ContactChannel): void {
  trackUsage(UsageEvent.ContactClicked, { channel })
}

export function ContactLinks({ className, prompt, showFooter = true }: ContactLinksProps) {
  const instagram = CONTACT[ContactChannel.Instagram]
  const email = CONTACT[ContactChannel.Email]
  const emailHref = `mailto:${email.address}?subject=${encodeURIComponent(email.subject)}`

  return (
    <div className={cn('flex items-center justify-center gap-2 whitespace-nowrap text-xs text-muted-foreground', className)}>
      {prompt ? <span>{prompt}</span> : null}
      <a
        href={instagram.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={TEST_IDS.contactInstagram}
        onClick={() => contactClicked(ContactChannel.Instagram)}
        className="inline-flex h-7 items-center gap-1.5 rounded-md bg-muted px-2 font-medium text-foreground transition-colors hover:bg-muted/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <InstagramGlyph className="size-3.5" aria-hidden="true" />
        @{instagram.handle}
      </a>
      <a
        href={emailHref}
        aria-label="Email"
        data-testid={TEST_IDS.contactEmail}
        onClick={() => contactClicked(ContactChannel.Email)}
        className="inline-grid size-7 place-items-center rounded-md transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Mail className="size-3.5" aria-hidden="true" />
      </a>
      {showFooter ? (
        <>
          <span aria-hidden="true">·</span>
          <a
            href="/privacy.html"
            data-testid={TEST_IDS.privacyLink}
            className="rounded-sm underline-offset-4 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            Privacy
          </a>
          <span aria-hidden="true">·</span>
          <AppVersion />
        </>
      ) : null}
    </div>
  )
}
